import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.jpg';

import banner1 from './images/banner1.jpg';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class sllaserMain extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/Zubehoer">Zubehör</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>SLLaser</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="SLLaser Headquater"/>
        </div>
        <div className="supMainTextLS">
          <h1>SL-Laser</h1>
          <Grid className="supMainInfo">
          <Row>
            <Col xsHidden smHidden md={5}>
              <Carousel  controls={false} interval={3000}>
                <Carousel.Item >
                    <img  src={InfoJumb1}  alt="SLLaser Headquater"  height="100%" />
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb2} alt="SLLaser Produktion"  height="100%"/>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb3} alt="SLLaser Erosion"  height="100%" />
                </Carousel.Item>
              </Carousel>
              </Col>
            <Col xsHidden md={7}>
              <h4>Die Fa. SL-Laser GmbH entwickelt und produziert seit über 25 Jahren Laser-Projektionssysteme zum exakten Positionieren und Ausrichten von Maschinen und Werkstücken. Nach den Anfängen im Holz und CNC-Bereich ist SL-Laser heute ebenso ein Begriff in der Flugzeugindustrie, bei der Fertigung von Betonfertigteilen und bei der Montage und Vermessung in vielen anderen Bereichen. Die Herstellung und Entwicklung der High-Tech-Systeme, sowie der Service und die Logistik befinden sich seit 2008 im neu gebauten Firmengebäude in Traunreut. Ein Stamm von erfahrenen Technikern und Ingenieuren betreut die Entwicklung der Elektronik, Software und Feinmechanik. Ein hoher Anteil an Eigenfertigung ist notwendig, um den technischem Anspruch und Qualitätsstandard der Produkte zu erfüllen. Der Service von SL-Laser kann dank langjähriger Erfahrung und eigens gebauter Anlagen schnell und gründlich jede Störung beheben und verlässliche Wartungsarbeiten ausführen. Der Vertrieb spricht fast alle Sprachen nationaler und internationaler Kunden. Falls nicht, greift SL-Laser auf ein weltweites Netz von Repräsentanten zurück.</h4>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden>
              <h4>Die Fa. SL-Laser GmbH entwickelt und produziert seit über 25 Jahren Laser-Projektionssysteme zum exakten Positionieren und Ausrichten von Maschinen und Werkstücken. ie Herstellung und Entwicklung der High-Tech-Systeme, sowie der Service und die Logistik befinden sich seit 2008 im neu gebauten Firmengebäude in Traunreut.
            </h4>
            </Col>
            <Col xs={12} md={{ span: 7, offset: 2 }}>
              <Button className="supMainButtonWebPage" variant="light" href="https://www.sl-laser.com/" target="_blank">Hersteller Homepage</Button>
            </Col>
          </Row>
        </Grid>
      </div>
        <br/>
          <section>
          <div className="supMainKeyWords White">
            <br/>
            <Grid>
              <Row>

              </Row>
              <br/>
              <Row className="show-grid">


              </Row>
            </Grid>
            <br/>
          </div>
          <br/>
        </section>

        </div>
    );
  }
}

export default sllaserMain;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/sllaser/mainPageSup.js